import _ from 'lodash'
import Vue from 'vue'
import Axios from 'axios'
import VueRouter from 'vue-router'
import Meta from 'vue-meta'
import VueLazyload from 'vue-lazyload'

import App from '@/App.vue'
import store from '@/vuex/Store'
import router from '@/Route.js'
import Settings from '@/config/Settings'
import Translation from '@/core/mixins/Translation'
import LangMixin from '@/core/mixins/Lang'
import CommonMixin from '@/mixins/Commons'
import Agent from '@/core/js/Agent'
import '@/core/js/Copyright'

Vue.prototype.$http = Axios.create({ baseURL: Settings.API_URL })
Vue.use(VueRouter)
Vue.use(Meta,{
  keyName: 'head'
})
Vue.use(VueLazyload)
Vue.mixin(Translation)
Vue.mixin(CommonMixin)


new Vue({
  el: '#App',
  store,
  router,
  mixins: [ LangMixin ],
  head() {
    return {
      htmlAttrs: { lang: this.lang },
      meta: [
        { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      ],
    }
  },
  data: () => ({
    $agent: null,
    isProd: process.env.NODE_ENV === 'production',
    // normal
    isDev: process.env.NODE_ENV !== 'production',
    // force prod
    // isDev: process.env.NODE_ENV === 'production',
  }),
  beforeCreate() {

    // enki.momentabiennale.com/fr
    // enki.momentabiennale.com/eng
    // const url = { fr: 'gdm.momentabiennale.com', en: 'gom.momentabiennale.com', host: window.location.host }

    if (window.location.protocol != "https:" && process.env.NODE_ENV == 'production') 
      window.location.protocol = "https"

    const path = { fr: '/fr', en: '/eng' }
    const url = { fr: 'enki.momentabiennale.com', en: 'enki.momentabiennale.com', host: window.location.host }
    const isMomentaServer = [url.fr, url.en].indexOf(url.host) > -1
    // const isMomentaServer = true
    this.isMomentaServer = isMomentaServer

    // console.log(this.$route);
    // console.log([path.fr, path.en].indexOf(this.$route.path) > -1);

    if(isMomentaServer) {
      // const urlLang = url.fr == url.host ? 'fr' : 'en'
      const urlLang = this.$route.path == path.fr ? 'fr' : 'en'
      if(this.$route.meta.name == 'museum' && this.$route.params.slug != 'introduction')
        this.$router.replace({ name: 'museum.' + this.$route.meta.lang, params: { slug: 'introduction' } })
      if(this.$route.meta.lang != urlLang && [path.fr, path.en].indexOf(this.$route.path) > -1)
        this.$router.replace({ name: this.$route.meta.name + '.' + urlLang })
    }
    this.$store.commit('app/LANG_CHANGED', this.$route.meta.lang)
    this.$store.commit('app/SET_FROM_ROUTE', this.$route)
    this.$store.commit('app/SET_TO_ROUTE', this.$route)
  },
  created() {
    this.$agent = Agent 
    // this.quality = this.$root.$agent.mobile 
    //             || this.$root.$agent.tablet != null 
    //             || this.$root.$agent.mobile != null
    //             || this.$root.$agent.browser == 'Safari' ? 'low' : 'high'

    this.isSafariOnPad = this.getInfos()
    this.quality = navigator.maxTouchPoints == 5 ? 'medium' : 'high'
    this.isIpad = navigator.maxTouchPoints == 5 ? true : false
    this.isSafari = this.$root.$agent.browser.name == 'Safari' ? true : false
    this.$galaxyTexture = null
    this .$theme = 'nw'
  },

  methods: {
    getInfos() {
      const isPad = navigator.maxTouchPoints == 5 ? true : false
      const isChrome = this.$root.$agent.ios ? true : false
      return isPad && !isChrome && this.$root.$agent.browser.name == 'Safari' ? true : false
    },
  },

  render: h => h(App)
})


















// WEBPACK FOOTER //
// ./src/main.js